module.exports = __webpack_public_path__ + "static/media/smellsandsoundslogo-no-background.9e5ee226.png";